import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Transition } from 'react-transition-group';
import { reDraw } from '../../../../helpers/common';
import { propBool, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import LargeArrowIcon from '../../../Icon/Svg/LargeArrowIcon';
const VerticalButton = (props) => {
    const { className, iconClassName, isShow, onClick, text } = props;
    return (_jsx(Transition, Object.assign({ in: isShow, mountOnEnter: true, onEnter: reDraw, onExit: reDraw, timeout: 0, unmountOnExit: true }, { children: (state) => (_jsxs("button", Object.assign({ className: `slide_viewer_main_slide_button ${className} ${state}`, onClick: onClick, type: 'button' }, { children: [_jsx("div", Object.assign({ className: 'icon_box' }, { children: _jsx(LargeArrowIcon, { className: iconClassName }) })), _jsx("span", Object.assign({ className: 'button_text' }, { children: text }))] }))) })));
};
VerticalButton.propTypes = {
    className: propStr().isRequired,
    iconClassName: propStr().isRequired,
    isShow: propBool().isRequired,
    onClick: propFunc().isRequired,
    text: propStr().isRequired,
};
export default VerticalButton;
